import { UpOutlined } from '@ant-design/icons';
import { Checkbox, Collapse } from 'antd';
import React, { useState } from 'react';
import { SpanLink } from '../../components/span_link/span_link';
import styles from './facet_group.less';

interface FacetGroupProps {
  facet: Record<string, number>;
  title: string;
  onChange: (values: string[]) => void;
  showMoreCount?: number;
  value: string[];
}

export const FacetGroup = (props: FacetGroupProps) => {
  const { title, onChange, showMoreCount = 5, value } = props;

  const facet = props.facet || {};

  const [showAll, setShowAll] = useState(false);

  const facetOptionsAll = Object.entries(facet).map(([key, count]) => ({
    label: (
      <div className={styles.checkboxText}>
        <span>{key}</span>
        <span>{count}</span>
      </div>
    ),
    value: key,
  }));

  const facetOptions = showAll ? facetOptionsAll : facetOptionsAll.slice(0, showMoreCount);

  return (
    <div className={styles.facet}>
      <Collapse
        defaultActiveKey={['1']}
        ghost
        expandIconPosition="end"
        expandIcon={({ isActive }) => <UpOutlined rotate={isActive ? 0 : 180} />}
      >
        <Collapse.Panel header={title} key="1">
          <Checkbox.Group
            options={facetOptions}
            value={value}
            onChange={onChange}
            className={styles.checkboxGroup}
          />
          {facetOptionsAll.length > showMoreCount && (
            <SpanLink onClick={() => setShowAll((s) => !s)}>
              Show {showAll ? 'Less' : 'All'}
            </SpanLink>
          )}
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};
